import React, { FC, useEffect } from 'react'
import styled from 'styled-components'

import {
  ModalBackdrop,
  ModalButtonContainer,
  ModalContainer,
  ModalMessage,
  ModalTitle,
} from './SharedModalComponents'

const ConfirmButton = styled.button`
  background: rgba(220, 38, 38, 0.8);
  color: white;
  border: 1px solid rgba(220, 38, 38, 0.6);
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  cursor: pointer;
  flex: 1;
  transition: all 0.2s ease;
  font-weight: 500;

  &:hover {
    background: rgba(220, 38, 38, 0.9);
    border-color: rgba(220, 38, 38, 0.8);
  }

  &:active {
    background: rgba(220, 38, 38, 1);
    transform: translateY(1px);
  }
`

const CancelButton = styled.button`
  background: #000000;
  color: white;
  border: 1px solid #666666;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  cursor: pointer;
  flex: 1;
  transition: all 0.2s ease;
  font-weight: 500;

  &:hover {
    background: #444444;
    border-color: #888888;
  }

  &:active {
    background: #555555;
    transform: translateY(1px);
  }
`

interface ConfirmationModalProps {
  isOpen: boolean
  title: string
  message: string
  confirmText?: string
  cancelText?: string
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmationModal: FC<ConfirmationModalProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    if (!isOpen) return

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onCancel()
      } else if (e.key === 'Enter') {
        onConfirm()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [isOpen, onCancel, onConfirm])

  if (!isOpen) return null

  return (
    <ModalBackdrop onClick={onCancel}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalTitle>{title}</ModalTitle>
        <ModalMessage>{message}</ModalMessage>
        <ModalButtonContainer>
          <CancelButton onClick={onCancel}>{cancelText}</CancelButton>
          <ConfirmButton onClick={onConfirm}>{confirmText}</ConfirmButton>
        </ModalButtonContainer>
      </ModalContainer>
    </ModalBackdrop>
  )
}
